import { Portfolio, Site, isPortfolio } from "../../features/sites/sites.module";
import { Link } from "@mui/material";

export interface PicColumnProps extends React.PropsWithChildren<{}> {
	item: Site | Portfolio;
}
export default function PicColumn(props: PicColumnProps) {
	const { item } = props;
	return (
		<>
			{!isPortfolio(item) ? (
				<>
					{item.pic_id ?
						<Link
							sx={{
								alignSelf: "center",
								textOverflow: "ellipsis",
								overflow: "hidden",
								whiteSpace: "nowrap",
								width: "100%",
								display: "block"
							}}
							title={item.pic_id}
							target="_blank"
							href={item.pic_link}>
							{item.pic_id}
						</Link> : "-"}
				</>
			) : ""}
		</>
	);
}
